module.exports = __webpack_public_path__ + "img/size.13497b56.svg";